<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
    data() {
        return {
            activity_name: '',
            form: {},
            totals: null,
            disableOnSubmit : false,
            hide: true,
            dictionary: {
                en: {
                    attributes: {
                        required: 'This field is required',
                    }
                },
            },
            sortedForm: {},
        }
    },

    props: ['url', 'getUrl', 'list', 'options', 'frequencyLabel', 'whyLabel', 'whatLabel'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
    },

    created() {
        for (const key in this.list) {
            if (this.list.hasOwnProperty(key)) {
                const element = this.list[key];
                var newKey = key.replace(/-/g, "_");

                this.form[newKey] = {
                    selected: false,
                    frequency: '',
                    why: '',
                    what_i_should_say: '',
                }
                this.dictionary.en.attributes[newKey + '[frequency]'] = '  ';
            }
        }
    },

    mounted() {
        this.getData();
        this.$forceUpdate();
        var self = this;
        setTimeout(function () { self.hide = false } , 1000)
        setInterval(function () { self.$forceUpdate() } , 1000)
        this.$validator.localize(this.dictionary);
    },

    watch: {
    },

    methods: {
        getData() {
            var self = this;
            axios
                .get(this.getUrl,
                    {
                        params: {
                        }
                    }
                )
                .then(response => {
                    for (const key in response.data.data.obstacles) {
                        if (response.data.data.obstacles.hasOwnProperty(key)) {
                            const element = response.data.data.obstacles[key];
                            this.form[key] = element;
                        }
                    }

                    self.$nextTick(function () {
                        self.sortForm();
                    })


                })
                .catch(error => {
                    console.log(error);
                });
        },

        keyWithHyphen(key) {
            return key.replace(/_/g, "-");
        },

        toggleSelection(key) {
            this.form[key].selected = !this.form[key].selected;
            this.$forceUpdate();
            // if (this.form[key].selected == false) {
            //     this.validateAndSubmit('obstacles-form', null, false);
            // }
        },

        validateForm(formId, key) {
            var self = this;
            
            
            this.$validator.validateAll(formId).then(result => {                
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    self.validateAndSubmit('obstacles-form');
                    self.toggleSelection(key);
                    self.$forceUpdate();
                    self.$nextTick(function () {
                        self.sortForm();
                    })
                }

            });
        },

        sortForm() {
            var form = this.form;
            var red = {};
            var amber = {};
            var green = {};
            var blue = {};


            for (const key in form) {
                if (form.hasOwnProperty(key)) {
                    const element = form[key];

                    if (element.frequency == '') {
                        blue[key] = element;
                        continue;
                    }
                    if (element.frequency === 'always' || element.frequency === 'frequently') {
                        red[key] = element;
                        continue;
                    }
                    if (element.frequency === 'sometimes') {
                        amber[key] = element;
                        continue;
                    }
                    if (element.frequency === 'rarely' || element.frequency === 'never') {
                        green[key] = element;
                        continue;
                    }
                }
            }

            this.sortedForm = {red, amber, green, blue};
        },
    },
}
</script>
